////////////////////////////////////////////////////////////////////////////////
// Constants
////////////////////////////////////////////////////////////////////////////////

export const MASK_CHAR = 'X';

////////////////////////////////////////////////////////////////////////////////
// Helpers
////////////////////////////////////////////////////////////////////////////////

export const calculateMask = (value: string | undefined): string => {
  if (!value) return '';
  const length = value.length;
  const substringStart = length - (length > 4 ? 4 : length);
  return `${MASK_CHAR.repeat(length > 4 ? length - 4 : 0)}${value?.substring(substringStart)}`;
};
